import React from "react";
import { Box, Typography } from "@mui/material";
import InputSelectionComponent from "../../../Dashboard/Component/inputSelection";
import Spinner from "../../../../Component/Spinner/Spinner";

const FIELD_WIDTH = 260;

function Field({ label, options, selectedOptions, handleChange, disabled }) {
  // InputSelectionComponent's <Select> already renders with className="form-control"
  // (its own single bordered box) — no extra wrapping border here, or it stacks
  // into a rectangle-inside-a-rectangle.
  return (
    <Box sx={{ width: FIELD_WIDTH, display: "flex", flexDirection: "column", gap: 0.6, opacity: disabled ? 0.55 : 1 }}>
      <Typography sx={{ fontSize: 12, fontWeight: 700, letterSpacing: "0.02em", textTransform: "uppercase", color: "#98a2b3" }}>
        {label}
      </Typography>
      <InputSelectionComponent options={options} selectedOptions={selectedOptions} handleChange={handleChange} disabled={disabled} />
    </Box>
  );
}

/**
 * Monitoring tab form for the V3 Conversations copy — isolated from
 * Conversations/Form.js (DashboardNav), which stays untouched for
 * ConversationsV2.
 *
 * Unlike DashboardNav, this is not a "configure and Generate a new run"
 * form: Monitoring here is a pure browse view over existing Discovery
 * history — cascading Brand -> Category -> Persona dropdowns built from
 * that history data (no monitoring-filter API call, no site suggestions,
 * no brand/product type switch, no Generate button). Selecting a full
 * Brand + Category + Persona combination loads the matching history
 * entry automatically.
 */
export default function MonitoringForm({
  brandItems,
  selectedBrand,
  onBrandChange,
  categoryItems,
  selectedCategory,
  onCategoryChange,
  personaItems,
  selectedPersona,
  onPersonaChange,
  loading,
  isEmpty,
}) {
  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
        <Spinner size={28} />
      </Box>
    );
  }

  if (isEmpty) {
    return (
      <Box sx={{ p: "12px 4px", color: "#667085", fontSize: 14 }}>
        No completed Discovery runs yet — Monitoring will populate once at least one Discovery run has completed.
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", gap: 3, flexWrap: "wrap", p: "20px 24px" }}>
      <Field label="Brand" options={brandItems} selectedOptions={selectedBrand} handleChange={onBrandChange} />
      <Field
        label="Category"
        options={categoryItems}
        selectedOptions={selectedCategory}
        handleChange={onCategoryChange}
        disabled={!selectedBrand?.length}
      />
      <Field
        label="Persona"
        options={personaItems}
        selectedOptions={selectedPersona}
        handleChange={onPersonaChange}
        disabled={!selectedCategory?.length}
      />
    </Box>
  );
}
